import { createContext } from "react";

import { BookingCalendarEventModel } from "../../BookingCalendarEventModel.ts";

export const BookingCalendarEventContext =
  createContext<BookingCalendarEventModel>({} as BookingCalendarEventModel);
